import React, { useEffect, useState } from "react";
import useTitle from "../Hooks/useTitle";
import Datagrid from "../Components/Datagrid";
import DatagridContext from "../Context/datagridContext";
import UnauthorizePage from "./UnauthorizePage";
import ForbiddenPage from "./ForbiddenPage";
import toolbar from "../Config/toolbarConfig";
import editSettings from "../Config/editSettingsConfig";
import { useTranslation } from "react-i18next";
import { MaskedTextBoxComponent } from "@syncfusion/ej2-react-inputs";
import { ComboBoxComponent } from "@syncfusion/ej2-react-dropdowns";

const AccountsPage = () => {
  const [url, setUrl] = useState("");
  const [from, setFrom] = useState("");
  const [status, setStatus] = useState(null);
  const { t } = useTranslation();

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useTitle(`${t("Accounts")} | Netileti`);
  
  const fetchData = async () => {
    setUrl(`${baseUrl}/accounts`);
    setFrom("Accounts");
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {}, [status]);

  const editTemplate = (props) => {
    return (
      <MaskedTextBoxComponent
        id={`phoneNumber_${props.rowIndex}`}
        name="phoneNumber"
        placeholder={t("Phone Number")}
        onChange={(e) => {
          if (props.onChange) {
            props.onChange({
              target: {
                name: "phoneNumber",
                value: e.value,
              },
            });
          }
        }}
        mask={"+90 (000)-000-0000"}
        value={props.phoneNumber || ""}
        floatLabelType="Always"
      />
    );
  };

  const formatPhoneNumber = (value) => {
    if (!value) return "";
    const numericValue = value.replace(/[^0-9]/g, "");
    if (numericValue.length !== 12) return value;

    return `+${numericValue.slice(0, 2)} (${numericValue.slice(
      2,
      5
    )})-${numericValue.slice(5, 8)}-${numericValue.slice(8)}`;
  };

  const columns = [
    {
      field: "id",
      headerText: "id",
      allowEditing: false,
      isPrimaryKey: true,
      visible: false,
    },
    {
      field: "firmName",
      headerText: t("Firm Name"),
      allowEditing: true,
      validationRules: { required: true, maxLength: 50 },
    },
    {
      field: "firmVkNo",
      headerText: t("Firm Vk No"),
      allowEditing: true,
      validationRules: { number: true, maxLength: 50 },
    },
    {
      field: "phoneNumber",
      headerText: t("Phone Number"),
      allowEditing: true,
      editTemplate: editTemplate,
      template: (props) => formatPhoneNumber(props.phoneNumber),
    },
    {
      field: "isActive",
      headerText: t("Active"),
      allowEditing: false,
      type: "Boolean",
      isCheckbox: "True",
      textAlign: "Center",
      filterTemplate: () => (
        <ComboBoxComponent
          dataSource={[
            { text: t("gridColumns.True"), value: "True" },
            { text: t("gridColumns.False"), value: "False" },
          ]}
          fields={{ text: "text", value: "value" }}
          change={(e) => {
            const selectedValue = e.value;
            const gridElement = document.getElementById("adaptivebrowser");
            if (gridElement) {
              const grid = gridElement.ej2_instances[0];

              if (grid) {
                if (selectedValue) {
                  // Filtreyi uygula
                  grid.filterByColumn("isActive", "equal", selectedValue);
                } else {
                  // Filtreyi temizle
                  grid.removeFilteredColsByField("isActive");
                }
              }
            }
          }}
        />
      ),
    },
    // {
    //   field: "isSelected",
    //   headerText: t("Selected"),
    //   allowEditing: false,
    //   isCheckbox: "True",
    //   textAlign: "Center",
    // },
  ];

  if (!url) {
    return <div></div>;
  }
  return (
    <div
      className="content e-content-animation"
      style={{ display: "flex", justifyContent: "center", height: "auto" }}
    >
      {status === 401 ? (
        <UnauthorizePage />
      ) : status === 403 ? (
        <ForbiddenPage />
      ) : (
        <DatagridContext.Provider
          value={{
            editSettings,
            toolbar: toolbar("CRUD"),
            url,
            from,
            setStatus,
          }}
        >
          <Datagrid columns={columns} />
        </DatagridContext.Provider>
      )}
    </div>
  );
};

export default AccountsPage;
